<template>
  <a-spin :spinning="loading">
    <div :class="bem.b()" @mouseleave="handleMouseleave">
      <a-directory-tree
        v-if="treeData?.length"
        v-bind="attrs"
        :block-node="true"
        multiple
        :tree-data="treeData"
        :expanded-keys="newExpandedKeys"
        :field-names="fieldNames"
        @expand="expand"
        @select="select"
        @mouseenter="handleMouseenter"
      >
        <!-- switcher-icon-slots -->
        <template #switcherIcon="slots">
          <slot name="switcherIcon" v-bind="slots">
            <caret-right-outlined v-if="!slots.expanded" />
            <caret-down-outlined v-else />
          </slot>
        </template>
        <template #title="slots">
          <div :class="bem.e('title')">
            <div>
              <!-- icon-slots -->
              <div v-if="$slots.icon" :class="bem.e('icon')">
                <slot name="icon" v-bind="slots" />
              </div>
              <!-- title-slots -->
              <slot name="treeTitle" v-bind="slots">
                <span>
                  {{ slots[fieldNames!['title']!] }}
                </span>
              </slot>
            </div>
            <!-- operate-slots -->
            <transition :duration="100">
              <div
                v-if="hoverTreeNodeItem&&(hoverTreeNodeItem[fieldNames!['key']!] ===
                  slots[fieldNames!['key']!])"
                :class="`${bem.e('operate')} ${hoverTreeNodeItem&&(hoverTreeNodeItem[fieldNames!['key']!] ===
                  slots[fieldNames!['key']!])&&((props.dropdownOpenState?.[slots[fieldNames!['key']!]]||props.operateDropdownOpen) ?? false) ? bem.is('open') : bem.is('close')}`"
              >
                <slot name="treeOperate" :data="slots" />
              </div>
            </transition>
          </div>
        </template>
      </a-directory-tree>
      <template v-else>
        <!-- empty-slots -->
        <slot name="empty">
          <ll-empty>
            <template #content>暂无数据</template>
          </ll-empty>
        </slot>
      </template>
    </div>
  </a-spin>
</template>
<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { operateTreeEmits, operateTreeProps } from './operate-tree'

import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons-vue'

// 1.defineOptions
defineOptions({ name: 'LlOperateTree' })

// 2.props/emits
const props = defineProps(operateTreeProps)
const emits = defineEmits(operateTreeEmits)

// 3.hooks
const attrs = useAttrs()

// 4.ref
const newExpandedKeys = ref<string[]>([])
const hoverTreeNodeItem = ref() // 鼠标移的node的数据
const bem = createNamespace('operate-tree')

// 5.methods
const handleMouseenter = ({ node }) => {
  hoverTreeNodeItem.value = node
}
const handleMouseleave = () => {
  hoverTreeNodeItem.value = undefined
}
// tree的展开事件
const expand = (expandedKeys: string[], data: any) => {
  newExpandedKeys.value = expandedKeys
  emits('expand', expandedKeys, data)
}
// tree点击树节点触发
const select = (selectedKeys: string[], e: Event) => {
  emits('select', selectedKeys, e)
}

// 6.watch
// 如果有数据并且输入框有内容则展开
watch(
  () => props.expandedKeys,
  (keys) => {
    if (keys) {
      newExpandedKeys.value = keys as string[]
    }
  },
  {
    deep: true,
    immediate: true,
  }
)
</script>
